import { CISO_OMS_API } from '@/api';

const state = {
  tableData: [],
};

const actions = {
  async fetchRASupplyPlan({ commit }, args) {
    const params = {
      startDate: args.tradeDateSelected,
      BA: args.coordinatorListSelected,
    };
    try {
      const { data } = await CISO_OMS_API.get('/availability/supply-plan', { params });
      commit('setTableData', data);
    } catch {
      this.$notify('Failed to Load Event Log', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};